
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(86[17]4|1160|3907|4996|9104)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
